const inputFocusFn = function (event) {
  if (event.target.matches?.('.opc-input-selectable input.zm-input__inner')) {
    setTimeout(() => {
      event.target.select?.();
    }, 100);
  }
};

export default {
  install() {
    if (this.$context.is.mobile) {
      document.addEventListener('focus', inputFocusFn, true);
    }
  },
  uninstall() {
    document.removeEventListener('focus', inputFocusFn, true);
  },
};
